const pay_shipping = [
  {
    path: '/pay_shippings',
    name: 'IndexPayShippings',
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics'],
    },
    component: () => import('@/_backoffice/_financial/components/internal_payment/driver/IndexPayShippings.vue'),
  },
  {
    path: '/pay_shippings/driver/:id',
    name: 'ShowDriverPayShipping',
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics'],
    },
    component: () => import('@/_backoffice/_financial/components/internal_payment/driver/ShowDriverPayShipping.vue')
  },
  {
    path: '/print_shipping',
    name: 'PrintShipping',
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics'],
    },
    component: () => import("@/_backoffice/_financial/components/internal_payment/driver/PrintPaymentDriver.vue"),
  },
]

export default pay_shipping
